function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Box } from "../box";
import Ripple from "../button/Ripple";
import { getContainerStyles, getSwitchBaseStyles, getSwitchTrackStyles, getRippleWrapperStyles, getInputStyles, getRippleRootStyles } from "./Switch.styles";
export var Switch = function Switch(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      checked = _ref.checked,
      onChange = _ref.onChange,
      _onMouseDown = _ref.onMouseDown,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      dataTestId = _ref['data-test-id'];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var handleChange = function handleChange(event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(checked, event);
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };

  var handleBlur = function handleBlur(event) {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };

  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-test-id": dataTestId,
    sx: function sx() {
      return getContainerStyles({
        disabled: disabled
      });
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    disabled: disabled,
    sx: function sx() {
      return getSwitchBaseStyles({
        checked: checked
      });
    }
  }), /*#__PURE__*/React.createElement(Ripple, null, function (_ref2) {
    var showRipple = _ref2.showRipple,
        ripple = _ref2.ripple;
    return /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: function sx(theme) {
        return getRippleWrapperStyles({
          theme: theme,
          checked: checked,
          focused: focused
        });
      },
      disabled: disabled
    }, /*#__PURE__*/React.createElement(Box, {
      as: "input",
      type: "checkbox",
      checked: checked,
      disabled: disabled,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onMouseDown: function onMouseDown(event) {
        showRipple(event);
        _onMouseDown === null || _onMouseDown === void 0 ? void 0 : _onMouseDown(event);
      },
      onMouseUp: function onMouseUp() {
        setFocused(false);
      },
      sx: function sx() {
        return getInputStyles({
          checked: checked
        });
      }
    }), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      disabled: disabled,
      sx: function sx() {
        return getSwitchTrackStyles({
          checked: checked
        });
      }
    }), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: function sx() {
        return getRippleRootStyles();
      }
    }, ripple));
  }));
};
Switch.displayName = 'Switch';